export default __webpack_public_path__ + "static/media/coins.b3d034c8.svg";